module.exports = {
      id: "icon-audio-play-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-audio-play-store",
      toString: function () {
        return this.url;
      }
    }